import React from 'react';
import './index.css';

import IconEdit from '../icons/IconEdit';

const CurrentCountEditable = ({row, onClick, isActive = false, disabled,countingMode = 'Parts',acceptedParts}) => {

    let idMatches = [];

    if (countingMode === 'Parts'){
        idMatches = acceptedParts ? acceptedParts.filter(part => row.id.includes(part.partnum)) : [];
    }else {
        idMatches = acceptedParts ? acceptedParts.filter(part => row.partnum.includes(part.partnum)) : [];
    }

  return (
    <span className="current-count-editable">
      <span className="current-count-editable__bin-name">
          {countingMode === 'Parts' ?
                  row.currentCount === null ? '--' : row.currentCount : +row.currentCount ? row.currentCount : isActive && row.partnum === isActive.filter(item => item === row.partnum)[0] ?
                  row.currentCount : '--'}
        {!disabled && !idMatches.length > 0 &&
          <IconEdit
            onClick={countingMode ==='Parts' ? () => {
                onClick({
                    partnum: row.primaryPartnum,
                    bin: row.binName,
                    currentCount: +row.currentCount ? row.currentCount : 0
                })
            } : () => {
                onClick({
                    partnum: row.partnum,
                    bin: row.primaryBin,
                    currentCount: +row.currentCount ? row.currentCount : 0
                })
            }
            }
            className="current-count-editable__icon current-count-editable__icon--edit"
          />
        }
      </span>
    </span>
  );
}

export default CurrentCountEditable;